// extracted by mini-css-extract-plugin
export var messageSideLeft = "_np-1";
export var messageSideRight = "_np-2";
export var subscribeToBackInStockBubbleContainer = "_np-0";